@if (teams().length === 0) {
  <div class="h-full flex justify-center align-center px-8 py-40">
    <span>No Active Standing Entries</span>
  </div>
} @else {
  <table class="timing-table table-auto w-full">
    <thead class="bg-surface-container text-on-surface-container text-xs sticky top-0">
      <tr>
        <th>P</th>
        <th>#</th>
        <th>CAR</th>
        <th class="text-left">TEAM/DRIVER</th>
        <th>PiC</th>
        <th>LAP</th>
        <th>GAP</th>
        @if (enableMoreColumns()) {
          <th>INTERVAL</th>
        }
        <th>LAST LAP</th>
        @if (enableMoreColumns()) {
          <th>SECTOR 1</th>
          <th>SECTOR 2</th>
          <th>SECTOR 3</th>
          <th>BEST LAP</th>
        }
      </tr>
    </thead>
    <tbody class="text-sm">
      <ng-container *ngFor="let team of teams(); trackBy: trackByFn">
        <tr
          class="hover:bg-surface-container-high"
          [ngClass]="timingTowerService.activeList().includes(team?.number) ? activeClass() : ''"
          [class.has-playback]="team?.playback?.url"
          [class.team-row-moved-up]="team?.positionChangeState === 'up'"
          [class.team-row-moved-down]="team?.positionChangeState === 'down'"
          (click)="toggleTeamSelection(team!)"
        >
          <td>
            <span
              [ngClass]="
                timingTowerService.activeList().includes(team?.number) ? activeNumberClass() : ''
              "
              >{{ team?.activeStanding?.position }}</span
            >
          </td>
          <td>
            <div
              class="rounded-sm flex items-center justify-center"
              [title]="team?.class"
              [style.background-color]="team?.classDetails?.background"
              [style.color]="team?.classDetails?.foreground"
            >
              <span>{{ team?.number }}</span>
            </div>
          </td>
          <td>
            <img
              class="w-6 h-6 object-contain"
              [src]="team?.manufacturer || team?.vehicle || '' | teamLogoLookup: team?.class"
              alt="Logo"
              [title]="team?.manufacturer || team?.vehicle"
            />
          </td>
          <td>
            <span class="flex">
              {{ team?.currentDriverFullName }}
              @if (team?.playback?.url) {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="red"
                  class="ml-1 mt-1 bi bi-play-circle"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path
                    d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445"
                  />
                </svg>
              }
            </span>
            <div style="font-size: 10px">
              <div>{{ team?.team }}</div>
            </div>
          </td>
          <td>{{ team?.classStanding?.position }}</td>
          <td>{{ team?.participantDetails?.currentLap }}</td>
          <td class="timing-data-bold">
            @if (team?.activeStanding?.gapFirstLaps > 0) {
              {{ team?.activeStanding?.gapFirstLaps }}L
            } @else {
              +{{
                team?.activeStanding?.gapFirstTime
                  ? (team?.activeStanding?.gapFirstTime || 0 | timespanShort)
                  : '0.000'
              }}
            }
          </td>
          @if (enableMoreColumns()) {
            <td class="timing-data-bold">
              @if (team?.activeStanding?.gapPreviousLaps > 0) {
                {{ team?.activeStanding?.gapPreviousLaps }}L
              } @else {
                +{{
                  team?.activeStanding?.gapPreviousTime
                    ? (team?.activeStanding?.gapPreviousTime || 0 | timespanShort)
                    : '0.000'
                }}
              }
            </td>
          }
          <td class="timing-data-bold">
            {{ team?.participantDetails?.lastLap?.time | timespanMs }}
          </td>
          @if (enableMoreColumns()) {
            <td class="timing-data-bold">
              @if (team?.currentLapSectorData[1]) {
                <span [ngClass]="team?.currentLapSectorData[1].className">
                  {{ team?.currentLapSectorData[1].time | timespanShort }}
                </span>
              } @else {
                <span>--</span>
              }
            </td>
            <td class="timing-data-bold">
              @if (team?.currentLapSectorData[2]) {
                <span [ngClass]="team?.currentLapSectorData[2].className">
                  {{ team?.currentLapSectorData[2].time | timespanShort }}
                </span>
              } @else {
                <span>--</span>
              }
            </td>
            <td class="timing-data-bold">
              @if (team?.currentLapSectorData[3]) {
                <span [ngClass]="team?.currentLapSectorData[3].className">
                  {{ team?.currentLapSectorData[3].time | timespanShort }}
                </span>
              } @else {
                <span>--</span>
              }
            </td>
            <td class="timing-data-bold">
              {{ team?.participantDetails?.bestLap?.time | timespanMs }}
            </td>
          }
        </tr>
      </ng-container>
    </tbody>
  </table>
}
